import { ClusterFailedChecks, PartialFailedCheck } from './types';

export function groupClusterFailedChecks(clusters: ClusterFailedChecks[]): PartialFailedCheck[] {
    let failedChecks: Record<string, PartialFailedCheck> = {};

    clusters.forEach((cluster) => {
        cluster.failed_checks.forEach((check) => {
            const testKey = check.test_key;

            if (!failedChecks[testKey]) {
                failedChecks[testKey] = {
                    testKey: testKey,
                    affectedClusters: 1,
                    affectedUrls: check.affected_urls,
                    lastFound: check.last_found,
                    sampleUrl: check.sample_url,
                };
            } else {
                failedChecks[testKey].affectedClusters!++;
                failedChecks[testKey].affectedUrls! += check.affected_urls;
                failedChecks[testKey].lastFound = failedChecks[testKey].lastFound!.localeCompare(check.last_found) < 0 ? check.last_found : failedChecks[testKey].lastFound;
            }
        });
    });

    return Object.keys(failedChecks).reduce((accumulated, testKey) => {
        return [...accumulated, failedChecks[testKey]];
    }, [] as PartialFailedCheck[]);
}
